import React from 'react';
import { TableCell, Box } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { THandleSortChange } from '../hooks/useReportFilters';
import { OffersReportSortInput } from '__generated__/graphql';

interface SortableTableHeaderProps {
  field: string;
  sortField?: keyof OffersReportSortInput;
  label: string;
  sortFields: OffersReportSortInput[];
  onSort: THandleSortChange;
  align?: 'left' | 'center' | 'right';
}

export default function SortableTableHeader({
  field,
  sortField,
  label,
  sortFields,
  onSort,
  align = 'left'
}: SortableTableHeaderProps) {
  if (sortField) {
    const isActive = sortFields.find(s => s[sortField]) ? true : false;
    const direction = isActive ? sortFields.find(s => s[sortField])?.[sortField] : null;

    return (
      <TableCell
        align={align}
        sx={{
          cursor: 'pointer',
          userSelect: 'none',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
          }
        }}
        onClick={() => onSort(sortField)}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          {label}
          <Box sx={{ display: 'flex', flexDirection: 'column', ml: 0.5 }}>
            <ArrowUpwardIcon
              fontSize="small"
              sx={{
                fontSize: 12,
                color: isActive && direction === 'asc' ? 'primary.main' : 'action.disabled',
                opacity: isActive && direction === 'asc' ? 1 : 0.3
              }}
            />
            <ArrowDownwardIcon
              fontSize="small"
              sx={{
                fontSize: 12,
                marginTop: '-2px',
                color: isActive && direction === 'desc' ? 'primary.main' : 'action.disabled',
                opacity: isActive && direction === 'desc' ? 1 : 0.3
              }}
            />
          </Box>
        </Box>
      </TableCell>
    );
  } else {
    return (
      <TableCell
        align={align}
      >
        {label}
      </TableCell>
    );
  }
}